import { render, staticRenderFns } from "./ShareContent.vue?vue&type=template&id=2beb9826&"
import script from "./ShareContent.vue?vue&type=script&lang=js&"
export * from "./ShareContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShareContent.vue"
export default component.exports